/**
 * Globo Filter - Collection State Preservation
 * 
 * Keeps the Collection filter showing all collections with initial counts
 * even when other filters (Color, Size, etc.) are applied.
 * 
 * Uses MutationObserver for instant restoration with minimal flicker.
 */
(function () {
    const STORAGE_KEY_PREFIX = 'globo_collection_pristine_';
    let initialCollectionHTML = null;
    let currentCollectionHandle = null;
    let mutationObserver = null;
    let isRestoring = false;

    function getCollectionHandle() {
        const match = window.location.pathname.match(/\/collections\/([^\/\?]+)/);
        return match ? match[1] : 'default';
    }

    function hasActiveFilters() {
        const urlParams = new URLSearchParams(window.location.search);
        for (const [key] of urlParams) {
            if (key.startsWith('filter.') || key.startsWith('pf_') || key === 'q') {
                return true;
            }
        }
        const selectedItems = document.querySelector('.globo-selected-items li');
        if (selectedItems) return true;

        const checkedFilters = document.querySelectorAll(
            '.gf-option-block:not([data-filter-type="Collection"]) button[aria-checked="true"]'
        );
        return checkedFilters.length > 0;
    }

    function getStorageKey() {
        return STORAGE_KEY_PREFIX + currentCollectionHandle;
    }

    function getPristineFromStorage() {
        try {
            return sessionStorage.getItem(getStorageKey());
        } catch (e) {
            return null;
        }
    }

    function savePristineToStorage(html) {
        try {
            sessionStorage.setItem(getStorageKey(), html);
        } catch (e) { }
    }

    function captureInitialCollection() {
        if (initialCollectionHTML) return true;
        currentCollectionHandle = getCollectionHandle();

        const collectionBlock = document.querySelector('.gf-option-block[data-filter-type="Collection"]');
        if (!collectionBlock) return false;

        const storedPristine = getPristineFromStorage();
        if (storedPristine) {
            initialCollectionHTML = storedPristine;
            return true;
        }

        if (!hasActiveFilters()) {
            initialCollectionHTML = collectionBlock.innerHTML;
            savePristineToStorage(initialCollectionHTML);
            return true;
        }

        initialCollectionHTML = collectionBlock.innerHTML;
        return true;
    }

    function restoreCollectionFilter() {
        if (!initialCollectionHTML || isRestoring) return;

        const collectionBlock = document.querySelector('.gf-option-block[data-filter-type="Collection"]');
        if (collectionBlock && collectionBlock.innerHTML !== initialCollectionHTML) {
            isRestoring = true;
            collectionBlock.innerHTML = initialCollectionHTML;

            requestAnimationFrame(() => {
                isRestoring = false;
            });
        }
    }

    function setupMutationObserver() {
        const collectionBlock = document.querySelector('.gf-option-block[data-filter-type="Collection"]');
        if (!collectionBlock || mutationObserver) return;

        mutationObserver = new MutationObserver((mutations) => {
            if (isRestoring) return;
            restoreCollectionFilter();
        });

        mutationObserver.observe(collectionBlock, {
            childList: true,
            subtree: true,
            characterData: true,
        });
    }

    // Initialize logic
    function init() {
        currentCollectionHandle = getCollectionHandle();

        const initInterval = setInterval(() => {
            const collectionBlock = document.querySelector('.gf-option-block[data-filter-type="Collection"]');
            if (collectionBlock) {
                clearInterval(initInterval);
                setTimeout(() => {
                    captureInitialCollection();
                    setupMutationObserver();
                }, 50);
            }
        }, 50);

        setTimeout(() => clearInterval(initInterval), 10000);

        // Listen for Globo events
        document.addEventListener('globo.filter.updated', () => {
            requestAnimationFrame(restoreCollectionFilter);
        });
        window.addEventListener('globoFilterRenderCompleted', () => {
            requestAnimationFrame(restoreCollectionFilter);
        });

        // Handle clear all
        document.addEventListener('click', (e) => {
            if (e.target.closest('.clear-link-button') || e.target.closest('[onclick*="clearAllFilter"]')) {
                try {
                    sessionStorage.removeItem(getStorageKey());
                    initialCollectionHTML = null;
                    if (mutationObserver) {
                        mutationObserver.disconnect();
                        mutationObserver = null;
                    }
                } catch (e) { }
                setTimeout(() => {
                    captureInitialCollection();
                    setupMutationObserver();
                }, 100);
            }
        });
    }

    // Ensure logic runs
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
